import React from "react";
import { connect } from "react-redux";
import CurrencyFormatter from "HelperFunctions/CurrencyFormatter";
import { US_CURRENCY_FORMAT } from "Constants/currencyConstants";
import { selectCheckPermission } from 'HelperFunctions/locations';

// Every money value in the admin front-end renders through here. The currency comes from the
// location's own Rails I18n format (Location#currency_format), which the backend also formats
// with, so what we print matches the server for any currency -- there is no locale -> currency
// table to keep in sync (TD1-10207).
//
// Renders a bare text node, exactly as the FormattedNumber it replaced did: a lot of CSS and at
// least one DOM-scraping reconciliation check (RentalBilling.tsx) depend on there being no extra
// wrapper element here.
export const CurrencyLabel = props => {
  const {
    value,
    location: { locale, currencyFormat },
    hideCurrency,
    forceUsd,
    checkPermission,
    alternativePermission,
    ...others
  } = props;

  const canViewNumber = (alternativePermission !== null && alternativePermission !== undefined) ?
                        alternativePermission :
                        checkPermission('view_pricing_billing')

  if (!canViewNumber) return (<span>-</span>);

  // TapGoods bills its own subscriptions in USD whatever currency the location sells in.
  // `hideCurrency` is a misnomer kept for its one caller (settings/account/Subscription.jsx):
  // it forces USD, it does not hide anything.
  const inUsd = forceUsd || hideCurrency;
  const formatted = CurrencyFormatter({
    locale: inUsd ? "en-US" : locale,
    currencyFormat: inUsd ? US_CURRENCY_FORMAT : currencyFormat,
    ...others,
  }).format(value);

  return forceUsd ? <>USD {formatted}</> : <>{formatted}</>;
}

const mapStateToProps = state => {
  const { location } = state.location;
  const checkPermission = selectCheckPermission(state);
  return { location, checkPermission };
}

export default connect(mapStateToProps, null)(CurrencyLabel);
